import React, { useEffect } from 'react';
import { UIStateProps, uiState } from '../../atoms/uiAtom';

import EmptyState from '../common/EmptyState';
import { ReactComponent as ImportantIcon } from '../../assets/important.svg';
import NotificationsList from './NotificationsList';
import { notificationState } from '../../atoms/notificationAtom';
import { useGetNotifications } from '../../hooks/notifications';
import { useSetRecoilState } from 'recoil';
import { useTranslation } from 'react-i18next';

export default function Notifications() {
  const { t } = useTranslation();
  const setNotificationState = useSetRecoilState(notificationState);
  const {
    data: notifications,
    isFetching: IsFetchingNotifications,
    isError: isErrorNotifications,
    refetch: refetchNotifications,
  } = useGetNotifications();

  useEffect(() => {
    refetchNotifications().then(() => {
      setNotificationState((prevState) => ({
        ...prevState,
        items: notifications?.data,
      }));
    });
  }, [notifications?.data, refetchNotifications, setNotificationState]);

  const setUiState = useSetRecoilState<UIStateProps>(uiState);

  useEffect(() => {
    setUiState((state) => ({
      ...state,
      isLoading: IsFetchingNotifications,
      hasError: isErrorNotifications,
    }));
  }, [IsFetchingNotifications, isErrorNotifications, setUiState]);

  return (
    <div className="notifications p-4">
      <h1 className="mb-4">{t('notifications')}</h1>
      <section className="widget">
        {notifications?.data.length === 0 && !IsFetchingNotifications ? (
          <EmptyState message={t('common.no.data')} icon={<ImportantIcon />} />
        ) : (
          <NotificationsList
            items={notifications?.data}
            isLoading={isErrorNotifications || IsFetchingNotifications}
          />
        )}
      </section>
    </div>
  );
}
